import styled from 'styled-components';

export const DisplayIconShowOrHideValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  width: 32px;
`;
